var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 455,
    height: 453,
    viewBox: "0 0 455 453",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.819,
    cy: 226.881,
    rx: 226.779,
    ry: 226.112,
    fill: "url(#paint0_radial_63_1979)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M294.442 66.2696L176.497 154.092L198.308 102.278L294.442 66.2696Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1621 66.2695L139.159 154.924L118.415 102.278L22.1621 66.2695Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.005 269.843L220.593 318.092L287.803 336.631L307.125 270.912L252.005 269.843Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71558 270.912L28.9187 336.631L96.1297 318.092L64.7171 269.843L9.71558 270.912Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3361 188.318L73.6072 216.721L140.344 219.692L137.973 147.794L92.3361 188.318Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M224.272 188.319L178.043 146.962L176.502 219.693L243.12 216.722L224.272 188.319Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1296 318.091L136.195 298.482L101.582 271.387L96.1296 318.091Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M180.412 298.482L220.596 318.091L215.025 271.387L180.412 298.482Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M220.596 318.093L180.412 298.484L183.612 324.748L183.257 335.8L220.596 318.093Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1296 318.093L133.469 335.8L133.232 324.748L136.195 298.484L96.1296 318.093Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M134.065 254.038L100.637 244.174L124.226 233.36L134.065 254.038Z",
    fill: "#2B2B2B",
    stroke: "#233447",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M182.551 254.038L192.389 233.36L216.097 244.174L182.551 254.038Z",
    fill: "#2B2B2B",
    stroke: "#233447",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1281 318.093L101.818 269.844L64.7156 270.913L96.1281 318.093Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M214.902 269.844L220.592 318.093L252.005 270.913L214.902 269.844Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M243.116 216.722L176.497 219.693L182.661 254.038L192.5 233.36L216.207 244.175L243.116 216.722Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.63 244.175L124.338 233.36L134.058 254.038L140.341 219.693L73.6038 216.722L100.63 244.175Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6091 216.723L101.584 271.389L100.636 244.175L73.6091 216.723Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M216.213 244.175L215.028 271.389L243.122 216.723L216.213 244.175Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M140.347 219.694L134.064 254.039L141.888 294.563L143.666 241.204L140.347 219.694Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M176.499 219.694L173.299 241.085L174.721 294.563L182.663 254.039L176.499 219.694Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M182.663 254.038L174.721 294.562L180.411 298.484L215.024 271.389L216.21 244.174L182.663 254.038Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M100.637 244.174L101.586 271.389L136.199 298.484L141.889 294.562L134.065 254.038L100.637 244.174Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M183.255 335.8L183.611 324.747L180.647 322.133H135.958L133.232 324.747L133.469 335.8L96.1296 318.092L109.169 328.788L135.603 347.208H181.003L207.555 328.788L220.594 318.092L183.255 335.8Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M180.409 298.484L174.719 294.562H141.884L136.195 298.484L133.231 324.748L135.958 322.133H180.646L183.61 324.748L180.409 298.484Z",
    fill: "#2B2B2B",
    stroke: "#2B2B2B",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M299.422 159.798L309.498 111.311L294.443 66.2705L180.41 151.122L224.269 188.319L286.264 206.502L300.015 190.458L294.088 186.18L303.571 177.505L296.221 171.8L305.704 164.551L299.422 159.798Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22729 111.311L17.303 159.797L10.902 164.551L20.385 171.8L13.1542 177.505L22.6372 186.18L16.7103 190.458L30.3422 206.501L92.3375 188.319L136.196 151.122L22.1631 66.2703L7.22729 111.311Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M286.262 206.502L224.267 188.32L243.115 216.722L215.021 271.389L252.005 270.913H307.125L286.262 206.502Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3394 188.32L30.3441 206.502L9.71851 270.913H64.7201L101.585 271.389L73.6104 216.722L92.3394 188.32Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M176.501 219.692L180.413 151.121L198.431 102.278H118.418L136.198 151.121L140.347 219.692L141.77 241.321L141.888 294.561H174.723L174.96 241.321L176.501 219.692Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 1.73782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M404.951 200.684C377.474 200.684 355.173 223.009 355.173 250.505C355.173 278.012 377.474 300.326 404.951 300.326C432.478 300.326 454.729 278.012 454.729 250.505C454.729 223.009 432.478 200.684 404.951 200.684Z",
    fill: "#0065FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M350.345 147.653C343.703 147.653 338.313 153.049 338.313 159.695C338.313 166.343 343.703 171.737 350.345 171.737C356.998 171.737 362.376 166.343 362.376 159.695C362.376 153.049 356.998 147.653 350.345 147.653Z",
    fill: "#0065FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M80.853 362.619C78.112 362.619 75.8875 364.846 75.8875 367.589C75.8875 370.333 78.112 372.559 80.853 372.559C83.599 372.559 85.8186 370.333 85.8186 367.589C85.8186 364.846 83.599 362.619 80.853 362.619Z",
    fill: "#0065FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_63_1979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.313 208.153C283.908 208.153 239.753 252.356 239.753 306.799C239.753 361.261 283.908 405.445 338.313 405.445C392.817 405.445 436.873 361.261 436.873 306.799C436.873 252.356 392.817 208.153 338.313 208.153Z",
    fill: "#3B3B3B",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_1979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.887 293.08H384.808V286.648C384.808 278.857 378.503 272.516 370.747 272.516H369.733L355.762 259.931C354.124 258.451 351.583 258.489 349.99 260.022L345.992 263.857L341.633 259.924C339.995 258.444 337.455 258.482 335.862 260.014L322.853 272.508H316.713C308.957 272.508 302.652 278.849 302.652 286.64V308.178C292.311 310.654 284.924 319.955 284.924 330.78C284.924 343.591 295.295 354.016 308.048 354.016C318.712 354.016 327.963 346.671 330.496 336.382H370.747C378.503 336.382 384.808 330.04 384.808 322.25V315.818H391.887V293.08ZM352.072 262.203C352.538 261.758 353.282 261.743 353.763 262.173L365.231 272.508H355.604L348.247 265.872L352.072 262.196V262.203ZM337.943 262.203C338.409 261.758 339.153 261.743 339.634 262.173L351.102 272.508H327.212L337.943 262.196V262.203ZM327.82 334.585C326.009 344.089 317.697 350.997 308.048 350.997C296.955 350.997 287.93 341.93 287.93 330.78C287.93 320.996 294.866 312.632 304.433 310.896C305.613 310.677 306.83 310.563 308.048 310.563C319.148 310.563 328.174 319.63 328.174 330.78C328.174 332.041 328.053 333.324 327.82 334.585ZM381.802 322.25C381.802 328.379 376.842 333.362 370.747 333.362H331.029C331.127 332.501 331.18 331.633 331.18 330.78C331.18 317.969 320.801 307.544 308.048 307.544C307.251 307.544 306.455 307.589 305.666 307.672V286.648C305.666 280.518 310.626 275.535 316.72 275.535H370.747C376.842 275.535 381.802 280.518 381.802 286.648V293.08H369.936C363.796 293.08 358.798 298.1 358.798 304.275V304.622C358.798 310.797 363.796 315.818 369.936 315.818H381.802V322.25ZM388.881 312.798H369.936C365.449 312.798 361.804 309.129 361.804 304.622V304.275C361.804 299.768 365.449 296.099 369.936 296.099H388.881V312.798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.295 299.693C368.845 299.693 366.846 301.694 366.846 304.162C366.846 306.631 368.838 308.631 371.295 308.631C373.753 308.631 375.744 306.631 375.744 304.162C375.744 301.694 373.753 299.693 371.295 299.693ZM371.295 305.604C370.499 305.604 369.853 304.955 369.853 304.155C369.853 303.354 370.499 302.705 371.295 302.705C372.092 302.705 372.738 303.354 372.738 304.155C372.738 304.955 372.092 305.604 371.295 305.604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.353 319.759C311.384 319.54 309.445 320.106 307.897 321.351L304.214 324.311L306.093 326.666L309.776 323.707C310.692 322.967 311.85 322.635 313.022 322.763C314.195 322.891 315.247 323.473 315.983 324.401C317.501 326.311 317.201 329.104 315.299 330.637L311.617 333.596L313.496 335.952L317.178 332.992C320.372 330.426 320.891 325.722 318.328 322.514C317.088 320.959 315.322 319.985 313.353 319.766V319.759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.319 337.846C305.402 338.586 304.252 338.918 303.072 338.79C301.9 338.662 300.848 338.08 300.111 337.152C298.593 335.242 298.894 332.449 300.795 330.924L304.478 327.964L302.599 325.609L298.916 328.568C295.722 331.135 295.204 335.838 297.766 339.047C299.006 340.602 300.773 341.576 302.742 341.795C303.02 341.825 303.298 341.84 303.568 341.84C305.244 341.84 306.867 341.274 308.19 340.202L311.872 337.242L309.994 334.887L306.311 337.846H306.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.873 325.476L302.295 333.187L304.175 335.544L313.753 327.832L311.873 325.476Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_63_1979",
    x: 223.976,
    y: 192.376,
    width: 228.673,
    height: 228.846,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.88824
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_63_1979"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_63_1979",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_63_1979",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(226.819 226.881) rotate(90) scale(186.196 186.746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#0065FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0065FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_1979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.964,
    height: 95.1724,
    fill: "white",
    transform: "translate(284.924 258.844)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.532697b30c49fc035dc555b56355872b.svg";
export { ForwardRef as ReactComponent };